// Max whole seconds whose millisecond value still fits in an ES integer (2147483647).
export const MAX_DURATION_SECONDS = 2147483;

export default function isValidDurationFilterValue(value) {
  if (value === '' || value === null || value === undefined) return false;
  if (typeof value === 'string' && !/^(0|[1-9]\d*)$/.test(value)) return false;

  const duration = Number(value);

  return Number.isInteger(duration)
    && duration >= 0
    && duration <= MAX_DURATION_SECONDS;
}
